import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'

import '../styles/top.css'
import Fade from 'react-reveal/Fade'

import { fetchTop } from '../store/tools.reducer'
import { addToCart } from '../store/cart.reducer'

import ModalItem from './ModalItem'
import ModalAddSuccess from './ModalAddSuccess'

const PRICE_ON_REQUEST = 'уточняйте'

function TopSales({fetchTop, addToCart, tools}) {
    const [showItem, setShowItem] = useState(false)
    const [showOk, setShowOk] = useState(false)
    const [item, setItem] = useState()
    const topTools = (Array.isArray(tools) ? tools : []).filter(Boolean).slice(0, 6)
    const isPriceOnRequest = (price) => String(price ?? '').trim().toLowerCase() === PRICE_ON_REQUEST

    const addItem = (item) => {
        addToCart (item)
        setShowOk(true)
    }

    const onItemClick = (item) => {
        setItem(item)
        setShowItem(true)
    }

    useEffect(() => {
        fetchTop()              
     },[])
 
     useEffect(() => {
     }, [tools])
    
    return(
        <div className='top'>
            <h2 className='top-h2'><img src='/images/Rectangle.svg' alt='square'/>  Выберете свой товар  <img src='/images/Rectangle.svg' alt='square'/></h2>
            <div className='wrap-top-list'>
                {
                    (topTools.length === 0) ? <div className='wrapper-loader'><img className='loader' src='/images/loader.svg' alt='loading...'/></div>: 
                    <div className='list-top'>
                        <div className='top-row'>
                            {topTools.slice(0, 3).map((tool, idx) => (
                                <div key={tool.id || `top-1-${idx}`} className='top-item'>
                                    <div className='top-img-wrap' onClick={e => onItemClick(tool)}><Fade left><img className='top-img' src={tool.image} alt='строительные материалы'/></Fade></div>
                                    <p className='top-title' onClick={e => onItemClick(tool)}>{tool.title}</p>
                                    <Fade top><p className='top-price'>{isPriceOnRequest(tool.price) ? tool.price : `${tool.price} byn`}</p></Fade>
                                    <button className='top-button' onClick={ e => addItem(tool)}>добавить в корзину</button>
                                </div>
                            ))}
                        </div>
                        <div className='top-row'>
                            {topTools.slice(3, 6).map((tool, idx) => (
                                <div key={tool.id || `top-2-${idx}`} className='top-item'>
                                    <div className='top-img-wrap' onClick={e => onItemClick(tool)}><Fade left><img className='top-img' src={tool.image} alt='строительные материалы'/></Fade></div>
                                    <p className='top-title' onClick={e => onItemClick(tool)}>{tool.title}</p>
                                    <Fade top><p className='top-price'>{isPriceOnRequest(tool.price) ? tool.price : `${tool.price} byn`}</p></Fade>
                                    <button className='top-button' onClick={ e => addItem(tool)}>добавить в корзину</button>
                                </div>
                            ))}
                        </div>
                    </div>
                } 
            </div>
            <NavLink className='top-a' to='/catalog'>смотреть больше</NavLink>
            {
                showOk ? 
                <ModalAddSuccess onHide={e => setShowOk(false)}/>
                : null
            }
            {
                showItem ? <ModalItem item={item} onHide={e => setShowItem(false)} addToCart={addToCart}/> : null
            }
        </div>
    )
}
const mapStateToProps = (state) => ({
    tools: state.tools
});

const mapDispatchToProps = {
    fetchTop,
    addToCart
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(TopSales);
/*
<div key={idx} className='top-item'>
                            <div className='top-img-wrap'><Fade left><img className='top-img' src={item.image} alt='строительные материалы'/></Fade></div>
                            <p className='top-title'>{item.title}</p>
                            <p className='top-price'><Fade top>{item.price}</Fade></p> 
                            <button className='top-button' onClick={ e => addToCart (item)}>добавить в корзину</button> 
                        </div>
*/

